import { Box, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';

import { TextBold, TextRegular, TextSemiBold, TextWithHighlight } from 'UiKit/typography';
import { Condition } from 'Component/others';
import { ChevronLeftIcon } from 'Asset/icon';
import { alertSuccess, alertResend, backToPreviousPage } from 'Const/forgot-password';

import usePostForgotPassword from 'Domain/forgot-password/usePostForgotPassword';
import { useForgotPasswordState } from 'View/forgot-password/state';

import styles from './styles.module.css';

const RequestSent = () => {
  const { resetState, updateState, state } = useForgotPasswordState();

  const { mutate: onForgotPassword } = usePostForgotPassword();

  const handleResendButton = () => onForgotPassword({ isResent: true, email: state?.email });
  const handleBackButton = () => resetState();

  const title = alertSuccess.title;
  const description = alertSuccess.description;

  useEffect(() => {
    let timer;
    if (state?.countdown > 0) {
      timer = setInterval(() => {
        updateState({ countdown: state?.countdown - 1 });
      }, 1000);
    } else {
      updateState({ isDisabled: false });
    }
    return () => clearInterval(timer);
  }, [state?.countdown, updateState]);

  return (
    <Box className={styles['request-sent__container']} data-testid="request-sent">
      <Flex flexDirection="column" gap="24px" marginBottom="20px">
        <TextSemiBold className={styles['title']} data-testid="request-sent-title">
          {title}
        </TextSemiBold>
        <TextWithHighlight
          className={styles['feedback__text']}
          text={description}
          textHighlight={state?.email}
          styleHighlight={{ color: 'var(--color-primary70)', fontWeight: 'bold' }}
          data-testid="request-sent-description"
        />
        <Flex className={styles['alert_text__container']}>
          <TextRegular fontSize="var(--font-body1)" data-testid="request-sent-alert">
            <span>{alertResend.message}</span>
          </TextRegular>

          <Condition statement={state?.isDisabled}>
            <TextBold className={styles['countdown__text']} data-testid="request-sent-countdown">
              {alertResend.action} ({state?.countdown}s)
            </TextBold>
          </Condition>

          <Condition statement={!state?.isDisabled}>
            <TextBold className={styles['resend__text']} onClick={handleResendButton} data-testid="request-sent-resend">
              {alertResend.action}
            </TextBold>
          </Condition>
        </Flex>
      </Flex>

      <Flex className={styles['back__button']} onClick={handleBackButton} data-testid="request-sent-back">
        <ChevronLeftIcon />
        <TextBold className={styles['back__button']}>{backToPreviousPage}</TextBold>
      </Flex>
    </Box>
  );
};

export default RequestSent;
